<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('team')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="50"
      resource_url="/eserman/team/datatables"
    ></generic-table>
  </div>

  <team-modal ref="team_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import TeamModal from "./team_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "TeamDatatable",
  components: { GenericTable, TeamModal, VLazyImage },
  props: {
    // module_settings: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          // width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.team_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete team member?"),
                    v,
                    () => {
                      del("/eserman/team", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.team_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    // edit(item) {
    //   let v = this;
    //   v.$refs.team_modal.edit_modal(item.uuid);
    // },
    // remove(item) {
    //   let v = this;
    //   confirm_deletion_dialog(
    //     v.$t("are you sure to delete representation?"),
    //     v,
    //     () => {
    //       del("/museum/representation", { uuid: item.uuid })
    //         .then(() => {
    //           v.refresh();
    //         })
    //         .catch((error) => {
    //           error_message(error);
    //         });
    //     }
    //   );
    // },
  },
  mounted() {
    let v = this;
    v.refresh();
    // window.new_product = () => {
    //   v.create();
    // };
  },
};
</script>

<style></style>
